import { forwardRef } from 'react';

import { Snackbar, IconButton, Box, Typography } from '@mui/material';
import { withStyles } from '@mui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { ReactComponent as Close } from 'asset/IconsPack/at_x-close.svg';
import { ReactComponent as Error } from 'asset/icons/error.svg';
import { ReactComponent as Info } from 'asset/icons/info.svg';
import { ReactComponent as Success } from 'asset/icons/success.svg';
// assets
import Warning from 'asset/icons/warning.svg';

// components
import { styles } from './toasterStyle';

const variantIcon = {
    default: Success,
    success: Success,
    warning: Warning,
    error: Error,
    info: Info,
};

const MySnackbarContent = forwardRef((props, ref) => {
    const { classes, className, message, onClose, variant } = props;
    const Icon = variantIcon[variant];

    return (
        <Box className={clsx(className, classes.box)} ref={ref}>
            <Box className={classes.messageContainer}>
                <Icon className={classes.icon} />
                <Typography className={classes.message}>{message}</Typography>
            </Box>
            <IconButton
                key="close"
                aria-label="Close"
                className={classes.closeIconBtn}
                onClick={onClose}
            >
                <Close className={classes.closeIcon} />
            </IconButton>
        </Box>
    );
});

MySnackbarContent.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string,
    message: PropTypes.string,
    onClose: PropTypes.func,
    variant: PropTypes.string,
};

const MySnackbarContentWrapper = withStyles(styles)(MySnackbarContent);

const Toaster = ({ open, message, closeToast, variant, duration, ...rest }) => {
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        closeToast();
    };
    return (
        <Snackbar
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            open={open}
            autoHideDuration={duration}
            onClose={handleClose}
        >
            <MySnackbarContentWrapper
                onClose={handleClose}
                variant={variant || 'default'}
                message={message || ''}
                {...rest}
            />
        </Snackbar>
    );
};

Toaster.propTypes = {
    open: PropTypes.bool,
    message: PropTypes.string,
    closeToast: PropTypes.func,
    variant: PropTypes.string,
    duration: PropTypes.number,
};

export default Toaster;
